import React from 'react'
import { IMAGE } from '../../configs/app-configs'
import { FormattedMessage } from 'react-intl'

const LandingFooter = () => {
  return (
    <div className='ld-footer pt-2'>
      <div className='d-none d-lg-flex justify-content-between'>
        <div className='float-md-left d-block d-md-inline-block mt-25'>
          <div>
            <FormattedMessage id='footer.copyRight' />
          </div>
          <div>
            <FormattedMessage id='footer.companySlogan' />
          </div>
        </div>
        <div className='float-md-right d-none d-md-block'>
          <a
            className='mr-1'
            href='https://www.apple.com/app-store/'
            target='_blank'
          >
            <img src={IMAGE.DOWNLOAD_APP_IOS} alt='DOWNLOAD ON APP STORE' />
          </a>
          <a href='https://play.google.com/store/apps' target='_blank'>
            <img src={IMAGE.DOWNLOAD_APP_ANDROID} alt='DOWNLOAD ON APP I' />
          </a>
        </div>
      </div>
      <div className='d-block d-lg-none text-center'>
        <div>
          <div className='d-flex justify-content-center'>
            <a
              className='mr-1'
              href='https://www.apple.com/app-store/'
              target='_blank'
            >
              <img
                className='w-90'
                src={IMAGE.DOWNLOAD_APP_IOS}
                alt='DOWNLOAD ON APP STORE'
              />
            </a>
            <a href='https://play.google.com/store/apps' target='_blank'>
              <img
                className='w-90'
                src={IMAGE.DOWNLOAD_APP_ANDROID}
                alt='DOWNLOAD ON APP I'
              />
            </a>
          </div>
          <div className='mt-1'>
            <FormattedMessage id='footer.copyRight' />
          </div>
          <div>
            <FormattedMessage id='footer.companySlogan' />
          </div>
        </div>
      </div>
    </div>
  )
}

export default LandingFooter
